import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5cb9bc3d&scoped=true&lang=pug"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=5cb9bc3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb9bc3d",
  null
  
)

export default component.exports